import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

/* Единая атмосфера страницы: несколько мягких световых пятен на всю высоту документа.
   Секции прозрачные, поэтому швов между блоками нет, свет перетекает от hero вниз.
   Пятна медленно смещаются при прокрутке (только transform). */
const BLOBS = [
  // дымка под дугой hero: связывает hero с подбором
  { top: "calc(100svh - 60px)", left: "50%", w: "110vw", h: 620, c: "rgba(62,139,255,0.34)", shift: -60 },
  { top: "190svh", left: "8%", w: "70vw", h: 640, c: "rgba(56,189,248,0.22)", shift: -140 },
  { top: "320svh", left: "92%", w: "70vw", h: 700, c: "rgba(62,139,255,0.26)", shift: -200 },
  { top: "450svh", left: "10%", w: "75vw", h: 700, c: "rgba(56,189,248,0.2)", shift: -260 },
  { top: "580svh", left: "90%", w: "75vw", h: 720, c: "rgba(62,139,255,0.26)", shift: -320 },
  { top: "700svh", left: "30%", w: "90vw", h: 760, c: "rgba(62,139,255,0.28)", shift: -380 },
];

const Blob = ({ b, progress, reduce }) => {
  const y = useTransform(progress, [0, 1], [0, reduce ? 0 : b.shift]);
  return (
    <motion.div
      style={{
        y,
        top: b.top,
        left: b.left,
        width: b.w,
        height: b.h,
        background: `radial-gradient(closest-side, ${b.c}, transparent)`,
      }}
      className="absolute -translate-x-1/2 -translate-y-1/2"
    >
      {/* сетка точек видна только внутри пятна: мотив «порядка» */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "radial-gradient(rgba(156,200,255,0.55) 1px, transparent 1.4px)",
          backgroundSize: "26px 26px",
          WebkitMaskImage: "radial-gradient(closest-side, #000, transparent 85%)",
          maskImage: "radial-gradient(closest-side, #000, transparent 85%)",
          opacity: 0.55,
        }}
      />
    </motion.div>
  );
};

export const PageAtmosphere = () => {
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll();
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
      {BLOBS.map((b) => (
        <Blob key={b.top} b={b} progress={scrollYProgress} reduce={reduce} />
      ))}
    </div>
  );
};
